import type { DashboardTabKey } from "@nlc/shared-types";

import {
  AlertTriangle,
  BarChart2,
  Briefcase,
  Clock,
  Layers,
  Loader2,
  Pencil,
  PenLine,
} from "lucide-react";

import type { DashboardCardConfig } from "./components/DashboardCard";

export const DASHBOARD_TAB_CONFIG: Record<
  DashboardTabKey,
  DashboardCardConfig
> = {
  // Super Admin · Team Leader · Customer Success
  ACTIVE_ACCOUNTS: {
    displayOrder: 7,
    icon: BarChart2,
    iconBgClass: "bg-utility-blue-100",
    iconClass: "text-utility-blue-600",
    label: "Active Accounts",
    to: "/projects",
  },
  // Customer Success
  ASSIGNED_ACCOUNTS: {
    displayOrder: 4,
    icon: Briefcase,
    iconBgClass: "bg-utility-brand-100",
    iconClass: "text-utility-brand-600",
    label: "Assigned Accounts",
    to: "/projects",
  },
  // Team Leader · Designer · Customer Success (featured)
  DUE_TODAY: {
    displayOrder: 1,
    featured: true,
    icon: Clock,
    iconBgClass: "bg-utility-warning-100",
    iconClass: "text-utility-warning-600",
    label: "Due Today",
    to: "/requests",
  },
  // Super Admin
  OPEN_REQUESTS: {
    displayOrder: 2,
    icon: Layers,
    iconBgClass: "bg-utility-brand-100",
    iconClass: "text-utility-brand-600",
    label: "Open Requests",
    search: { tab: "open" },
    to: "/requests",
  },
  // Team Leader
  OVERDUE: {
    displayOrder: 9,
    icon: AlertTriangle,
    iconBgClass: "bg-utility-gray-200",
    iconClass: "text-utility-gray-400",
    label: "Overdue",
    search: { tab: "all-requests" },
    to: "/requests",
  },
  // Super Admin
  OVERDUE_REQUESTS: {
    displayOrder: 8,
    icon: AlertTriangle,
    iconBgClass: "bg-utility-gray-200",
    iconClass: "text-utility-gray-400",
    label: "Overdue Requests",
    search: { tab: "overdue" },
    to: "/requests",
  },
  // Team Leader (processing + revising are sections inside team-requests tab)
  PROCESSING: {
    displayOrder: 5,
    icon: Loader2,
    iconBgClass: "bg-utility-brand-100",
    iconClass: "text-utility-brand-600",
    label: "Processing",
    search: { tab: "team-requests" },
    to: "/requests",
  },
  // Designer
  REQUESTS_ASSIGNED_TO_ME: {
    displayOrder: 3,
    icon: Pencil,
    iconBgClass: "bg-utility-brand-100",
    iconClass: "text-utility-brand-600",
    label: "Assigned to Me",
    search: { tab: "assigned-to-me" },
    to: "/requests",
  },
  // Team Leader · Designer
  REVISING: {
    displayOrder: 6,
    icon: PenLine,
    iconBgClass: "bg-utility-pink-100",
    iconClass: "text-utility-pink-600",
    label: "Revising",
    search: { tab: "team-requests" },
    to: "/requests",
  },
};
